module.exports = __webpack_public_path__ + "static/media/kerning.baa0ac67.svg";